/*
 * Copyright 2025 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/mobile-mobile/blob/master/LICENSE.md
 */
@file:Suppress("MatchingDeclarationName")

package org.mifos.mobile.feature.passcode.verifyPasscode

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavOptions
import kotlinx.serialization.Serializable
import org.mifos.mobile.core.ui.composableWithPushTransitions

sealed class VerifyPasscodeRoute {
    @Serializable
    data object Standard : VerifyPasscodeRoute()

    @Serializable
    data object Biometric : VerifyPasscodeRoute()

    @Serializable
    data object Pin : VerifyPasscodeRoute()
}

fun NavController.navigateToVerifyPasscodeScreen(
    navOptions: NavOptions? = null,
) {
    navigate(
        VerifyPasscodeRoute.Standard,
        navOptions,
    )
}

fun NavGraphBuilder.passcodeDestination(
    onPasscodeConfirm: () -> Unit,
) {
    composableWithPushTransitions<VerifyPasscodeRoute.Standard> {
        VerifyPasscodeScreen(
            onPasscodeConfirm = onPasscodeConfirm,
        )
    }
}
